exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".van-button[data-v-32803869]{margin:.1rem .5rem}", ""]);

// exports
